module.exports = __webpack_public_path__ + "img/ИФ-1(А)-025.4284bed7.png";